<template>
  <div class="min-h-screen bg-gradient-to-b from-gray-50 to-white">
    <!-- Hero Section -->
    <section class="relative py-20 bg-gradient-to-r from-green-700 via-teal-400 to-green-900 text-white overflow-hidden">
      <div class="absolute inset-0 bg-black/10"></div>
      
      <div class="relative max-w-7xl mx-auto px-5 sm:px-10 md:px-12 lg:px-5 py-24">
        <div class="text-center space-y-6" data-aos="fade-up" data-aos-duration="1000">
          <div class="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm">
            <span class="w-2 h-2 bg-white rounded-full mr-2"></span>
            Community Engagement
          </div>
          
          <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white">
            Public Participation
          </h1>
          
          <p class="text-xl text-white/90 leading-relaxed max-w-3xl mx-auto">
            We believe in transparent and inclusive ltenviromonitoring decision-making through active community involvement and stakeholder engagement
          </p>
        </div>
      </div>
    </section>

    <!-- Content Section -->
    <section class="py-20">
      <div class="max-w-7xl mx-auto px-5 sm:px-10 md:px-12 lg:px-5">
        <!-- Documents Section -->
        <div class="space-y-8" data-aos="fade-up" data-aos-duration="1000">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">Public Participation Documents</h2>
            <p class="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Download the document below to participate in our environmental assessment process. Your feedback is valuable to us.
            </p>
          </div>

          <!-- Single Document Card -->
          <div class="max-w-2xl mx-auto">
            <div class="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div class="flex items-start space-x-6">
                <!-- PDF Icon -->
                <div class="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                  </svg>
                </div>
                
                <!-- Document Content -->
                <div class="flex-1">
                  <h3 class="text-xl font-semibold text-gray-900 mb-3">COE DRAFT BASIC ASSESSMENT REPORT</h3>
                  <p class="text-gray-600 mb-4 leading-relaxed">
                    development centre of excellence on climate smart 
agriculture for livestock and crops, arc roodeplaat campus.
                  </p>
                  <a href="/COE DRAFT BASIC ASSESSMENT REPORT - Mar - Apr 2026.pdf" download class="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-full font-medium hover:bg-green-700 transition-colors duration-300">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                    </svg>
                    Download PDF
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Contact CTA -->
          <div class="text-center mt-12">
            <p class="text-gray-600 mb-4">Have questions or feedback about this document?</p>
            <router-link to="/contact" class="inline-flex items-center px-8 py-3 bg-green-600 text-white rounded-full font-medium hover:bg-green-700 transition-colors duration-300">
              Contact Us
              <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

export default {
  name: 'PublicParticipation',
}
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
